/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/***************************************************************************
* ------------------------------------------------------------------------
* Copyright 2021 VMware, Inc.  All rights reserved. VMware Confidential
* ------------------------------------------------------------------------
*
*/

const prefix = 'policies';

export const natPolicyBreadcrumbTitle = `${prefix}.natPolicyBreadcrumbTitle`;
export const natRuleBreadcrumbTitle = `${prefix}.natRuleBreadcrumbTitle`;

export const ENGLISH = {
    [natPolicyBreadcrumbTitle]: 'NAT Policy',
    [natRuleBreadcrumbTitle]: 'NAT Rule',
};
